const updateKanban = (state, action) => {
  if (state === undefined) {
    return {
      tasks: [],
      columns: [],
      columnOrder: ["1", "2", "3"],
      error: null,
      kanbanLoading: true
    };
  }

  switch (action.type) {
    case "KANBAN_REQUESTED":
      return {
        ...state.kanban,
        kanbanLoading: true
      };
    case "KANBAN_LOADED":
      return {
        ...state.kanban,
        kanbanLoading: false,
        tasks: action.payload
      };
    case "KANBAN_COLUMNS":
      return {
        ...state.kanban,
        ...action.payload
      };
    case "KANBAN_DRAGGED":
      const { destination, source, draggableId } = action.payload;
      const start = state.kanban.columns[source.droppableId];
      const finish = state.kanban.columns[destination.droppableId];
      const startTaskIds = Array.from(start.taskIds);

      startTaskIds.splice(source.index, 1);
      const newStart = {
        ...start,
        taskIds: startTaskIds
      };

      const finishTaskIds = Array.from(finish.taskIds);
      finishTaskIds.splice(0, 0, draggableId);
      const newFinish = {
        ...finish,
        taskIds: finishTaskIds
      };
      return {
        ...state.kanban,
        tasks: [...state.kanban.tasks, action.payload],
        columns: {
          ...state.kanban.columns,
          [newStart.id]: newStart,
          [newFinish.id]: newFinish
        }
      };

    case "KANBAN_ERROR":
      return {
        ...state.kanban,
        kanban: {
          tasks: {},
          columns: {},
          columnOrder: []
        },
        kanbanLoading: false,
        error: action.payload
      };

    default:
      return state.kanban;
  }
};

export default updateKanban;
